import type { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

import { useToken } from "@/hooks/useToken";
import { useAuthStore } from "@/stores/auth";

export const authGuard = (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const { getToken } = useToken();
  const authStore = useAuthStore();
  const token = getToken();
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresOwner = to.matched.some((record) => record.meta.requiresOwner);

  if (!requiresAuth) {
    next();
    return;
  }

  if (!token) {
    next({ path: "/login", query: { redirect: to.fullPath } });
    return;
  }

  if (requiresOwner && !authStore.isOwner) {
    next({ path: "/users" });
    return;
  }

  next();
};
